
import {defineComponent} from 'vue'
import {UtilityHelper} from "@/helpers/UtilityHelper";
import InputText from "@/components/UI/InputText.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {EnumClassNamePimEnum} from "@/models/enum/EnumClassNamePimEnum";
import {PimFeedbackRestDtoModel} from "@/models/api/pharma-pim-mgmt/PimFeedbackRestDtoModel";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "PimFeedbackPanelOld",
  emits: ["submitPimFeedback", "submitPimFeedbackCancel"],
  components: {InputTextEditor, InputText, InputSelect},
  props: {
    isGeneralRemark: {
      type: Boolean,
      required: true,
    },
    isShowFieldCode: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldCode: {
      type: String,
      required: false,
    },
    textFragmentId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      localFeedback: PimFeedbackRestDtoModel.createWithDefaults(),
      localFieldCode: this.fieldCode,
      enumFragmentNameCode: [] as CodeDescriptionRestDto[],
      enumPimProductFieldCode: [] as CodeDescriptionRestDto[],
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
  },
  methods: {
    async initialize(): Promise<void> {
      [
        this.enumFragmentNameCode,
        this.enumPimProductFieldCode
      ] = await Promise.all([
        EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNamePimEnum.TEXT_FRAGMENT_NAME, DpModuleEnum.CPC),
        EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNamePimEnum.PIM_PRODUCT_FIELD, DpModuleEnum.CPC)
      ]);
      this.reloadContent();
    },
    reloadContent(): void {
      this.localFeedback.field_code = this.fieldCode;
      this.localFeedback.text_fragment_id = this.textFragmentId;
    },
    submitPimFeedback(): void {
      this.$emit('submitPimFeedback', this.localFeedback);
    },
    submitPimFeedbackCancel(): void {
      this.$emit('submitPimFeedbackCancel');
    },
  }
})
